export default "__VITE_ASSET__2f228088__"